// const commonEnvironments = (baseUrl: string) => ({
//   gaTrackingId: 'G-H7TCE340TS',
//   sendFormUrl: `${baseUrl}/customer/onboarding`,
//   allLoans: `${baseUrl}/customer/products`,
//   contactUs: `${baseUrl}/customer/onboarding/contact-us`,

// });

// export default commonEnvironments;

export const commonEnvironments = {
  devBaseUrls: {
    customerBaseUrl: 'https://customers.dev.qualisdigital.africa',
    baseUrl: 'https://sso.dev.qualisdigital.africa',
    systemConfigurationsBaseUrL:
      'https://system-configurations.dev.qualisdigital.africa',
    salesOnboardingBaseUrL:
      'https://onboarding-service.dev.qualisdigital.africa',
  },

  preprodBaseUrls: {
    customerBaseUrl: 'https://customers.preprod.qualisdigital.africa',
    baseUrl: 'https://sso.preprod.qualisdigital.africa',
    systemConfigurationsBaseUrL:
      'https://system-configurations.preprod.qualisdigital.africa',
    salesOnboardingBaseUrL:
      'https://onboarding-service.preprod.qualisdigital.africa',
  },

  prodBaseUrls: {
    customerBaseUrl: 'https://customers.qualisdigital.africa',
    baseUrl: 'https://sso.qualisdigital.africa',
    systemConfigurationsBaseUrL:
      'https://system-configurations.qualisdigital.africa',
    salesOnboardingBaseUrL: 'https://onboarding-service.qualisdigital.africa',
  },
  // validateShortId: 'https://dev-sso.qualisdigital.co/link',
  testingUrl: 'https://enhpzwr4lk1dc.x.pipedream.net/',
  gaTrackingId: 'G-H7TCE340TS',
};

//https://customers.qualisdigital.co/customer/products

export const googleAnalyticsTitle = {
  PAGE_VIEW: 'page_view',
  PRODUCT_NAME: 'qualis web',
  EVENT_CATEGORY: 'qualis',
};

export const pageTitle = {
  HOMEPAGE: 'Homepage',
  FAQ: 'FAQ Page',
  STARTA: 'Starta Loan',
  SKULU: 'skulu Loan',
  DEVICE: 'device Loan',
  CONTACT: 'Contact Page',
  ABOUT_US: 'About Us Page',
  APPLICATION_CIVILSERVANT: 'Civil Servant Loan Application',
  APPLICATION_PERSONAL: 'Personal Loan Application',
  APPLICATION_MOU: 'MOU loan Application',
  APPLICATION_STARTA: 'Starta Loan Application',
  APPLICATION_SKULU: 'Skulu Loan Application',
  APPLICATION_DEVICE: 'Device Loan application',
};
